<div *ngIf="cellData" class="sh-status-cell">
	@if (display) {
		<prism-tooltip [text]="display.message" placement="top">
			<mat-icon [class]="display.class" fontSet="prism-mat" [fontIcon]="display.icon"></mat-icon>
		</prism-tooltip>
	}
</div>
